<template>
  <validation-provider
    :rules="rules"
    :name="name"
    v-bind="$attrs"
    mode="lazy"
    v-slot="{ errors, valid, invalid, validated }"
  >
    <b-form-group>
      <slot name="label">
        <label v-if="label" class="form-control-label">
          {{ label }}
        </label>
      </slot>
      <div
        :class="[
          { 'input-group': true },
          { focused: focused },
          { 'input-group-alternative': alternative },
          { 'has-label': label || $slots.label },
          inputGroupClasses,
        ]"
      >
        <div class="input-group-prepend">
          <span class="input-group-text">
            <span>$</span>
          </span>
        </div>

        <slot v-bind="slotData">
          <CurrencyInput
            v-model="innerValue"
            v-bind="$attrs"
            :valid="valid"
            :required="required"
            :id="inputId"
            class="form-control"
            :class="[
              { 'is-valid': valid && validated && successMessage },
              { 'is-invalid': invalid && validated },
              inputClasses,
            ]"
          />
        </slot>
        <div v-if="$slots.appendButton" class="input-group-append">
          <slot name="appendButton"> </slot>
        </div>
        <div v-if="appendIcon || $slots.append" class="input-group-append">
          <span class="input-group-text">
            <slot name="append">
              <i :class="appendIcon"></i>
            </slot>
          </span>
        </div>
        <small v-if="$slots.infoBlock">
          <slot name="infoBlock"></slot>
        </small>
      </div>
      <slot name="success">
        <div class="valid-feedback" v-if="valid && validated && successMessage">
          {{ successMessage }}
        </div>
      </slot>
      <slot name="error">
        <div v-if="errors[0]" class="invalid-feedback" style="display: block;">
          {{ errors[0] }}
        </div>
      </slot>
    </b-form-group>
  </validation-provider>
</template>
<script>
import CurrencyInput from "vue2-currency-input";
export default {
  inheritAttrs: false,
  components: { CurrencyInput },
  name: "base-input",
  props: {
    required: {
      type: Boolean,
      description: "Whether input is required (adds an asterix *)",
    },
    group: {
      type: Boolean,
      description:
        "Whether input is an input group (manual override in special cases)",
    },
    alternative: {
      type: Boolean,
      description: "Whether input is of alternative layout",
    },
    label: {
      type: String,
      description: "Input label (text before input)",
    },
    error: {
      type: String,
      description: "Input error (below input)",
    },
    successMessage: {
      type: String,
      description: "Input success message",
      default: "",
    },
    labelClasses: {
      type: String,
      description: "Input label css classes",
      default: "  ",
    },
    inputClasses: {
      type: String,
      description: "Input css classes",
    },
    inputGroupClasses: {
      type: String,
      description: "Input group css classes",
    },

    value: {
      type: Number,
      description: "Initial Value",
    },

    appendIcon: {
      type: String,
      description: "Append icon (right)",
    },
    prependChar: {
      type: String,
      description: "Preprend an a symbol on the textbox",
    },
    prependIcon: {
      type: String,
      description: "Prepend icon (left)",
    },
    rules: {
      type: [String, Array, Object],
      description: "Vee validate validation rules",
      default: "",
    },
    name: {
      type: String,
      description: "Input name (used for validation)",
      default: "",
    },
    inputId: {
      type: String,
      description: "Input Id",
      default: "",
    },
  },
  data() {
    return {
      focused: false,
      innerValue: null,
    };
  },
  created() {
    this.innerValue = this.value;
  },
  watch: {
    value(val) {
      this.innerValue = val;
    },
    innerValue(val) {
      this.$emit("input", val);
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
      };
    },
    slotData() {
      return {
        focused: this.focused,
        error: this.error,
        ...this.listeners,
      };
    },
    hasIcon() {
      const { append, prepend, prependChar } = this.$slots;
      return (
        append !== undefined ||
        prepend !== undefined ||
        prependChar !== undefined ||
        this.appendIcon !== undefined ||
        this.prependIcon !== undefined ||
        this.prependChar ||
        this.group
      );
    },
  },
};
</script>
<style></style>
